import styled from '@emotion/styled'

import { calcRem, breakpoint } from 'component-library/__styling/style-functions'
import { easing, colors, fonts } from 'component-library/__styling/settings'
import { conditionalStyles } from 'component-library/__styling/conditional-styles'
import { WebLink, WebLinkProps } from 'common/navigation/web-link'
import { createPropFilter } from 'common/emotion'

interface Props {
    isCurrent: boolean
}

export const StyledLink = styled(WebLink, {
    shouldForwardProp: createPropFilter<WebLinkProps>()(['isCurrent']),
})<Props>(
    ({ theme }) => ({
        fontSize: calcRem(16),
        fontWeight: 500,
        position: 'relative',
        zIndex: 1,
        display: 'inline-block',
        flex: '0 1 auto',
        margin: 0,
        padding: calcRem(12, 10),
        textDecoration: 'none',
        textTransform: 'uppercase',
        transition: `color ${easing.easeOut.fast}, border ${easing.easeOut.fast}, font-size ${easing.easeOut.fast}, margin ${easing.easeOut.fast}`,

        [breakpoint('lg')]: {
            padding: calcRem(11, 12),
        },

        '&::before, &::after': {
            transition: `height ${easing.easeOut.fast}, bottom ${easing.easeOut.fast}`,
            position: 'absolute',
            right: calcRem(8),
            left: calcRem(8),
            height: 0,
            content: `''`,
        },

        '&::after': {
            bottom: 0,
            background: colors.black,
        },

        '&:focus': {
            outline: 'none',

            '&::after': {
                height: calcRem(4),
            },
        },

        '&:first-child': {
            paddingLeft: 0,
            '&::before, &::after': {
                left: 0,
            },
        },
        fontFamily: fonts.thewest.sansSerif,
        color: colors.thewest.greyGorilla,
        '&::before': {
            top: 0,
            background: theme.sectionValues.primaryColor,
        },
        '&:hover': {
            color: theme.sectionValues.primaryColor,
            '&::before': {
                height: calcRem(4),
            },
        },
    }),
    ({ isCurrent }) => {
        return conditionalStyles(isCurrent === true, {
            '&::before': {
                height: calcRem(4),
            },
        })
    }
)
